module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": 'Oops!',
      "size": 'xs',
      "disableOutsideClick": true
    }
  }, [_c('body', {
    staticClass: "px-7 pt-7 pb-4 flex-grow overflow-hidden"
  }, [(_vm.deleteCourse) ? _c('div', {
    staticClass: "mt-3 justify-center items-center"
  }, [_c('span', {
    staticClass: "justify-center"
  }, [_vm._v("This course was removed by your teacher "), _c('br'), _vm._v("\n        or an administrator at your school.\n      ")])]) : _c('div', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "text-center mb-3"
  }, [_c('i', {
    staticClass: "fa-regular fa-face-frown text-4xl text-primary"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center text-gray-800 px-10"
  }, [_vm._v("\n        Your "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("access to this course")]), _vm._v(" has been removed by a "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("teacher")]), _vm._v("\n        or an "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("administrator ")]), _vm._v("at your school. You must "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("contact them")]), _vm._v(" to \n        be added back before your can join the Roundtable.\n      ")])])]), _vm._v(" "), _c('footer', {
    staticClass: "flex my-8 center items-center"
  }, [_c('button', {
    staticClass: "px-5 py-2 bg-primary rounded cursor-pointer text-white font-semibold",
    on: {
      "click": _vm.backToDashboard
    }
  }, [_vm._v("\n      Go to Dashboard\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-764b8006!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/removedStudentFromSchoolModal/removedStudentFromSchoolModal.vue
// module id = 2434
// module chunks = 61